import { EhrDetails } from "../../../../domain/ehr";
import { CxFeatureFlags } from "../../../../domain/feature-flags";

export type SharedState = {
  authToken?: string;
  baseUrl?: string;
  ehrDetails?: EhrDetails;
  isLoaded?: boolean;
  isMetriportUser?: boolean;
  isUserInSandbox?: boolean;
  userEmail?: string;
  isAmazonUser?: boolean;
  isTeladocUser?: boolean;
  hasDashV2Access?: boolean;
  featureFlags?: CxFeatureFlags;
};

export enum SharedStateActionType {
  set,
}

export type SharedStateAction = {
  type: SharedStateActionType.set;
  authToken: string;
  baseUrl: string;
  ehrDetails: EhrDetails | undefined;
  isMetriportUser: boolean;
  isUserInSandbox: boolean;
  userEmail?: string;
  isLoaded: boolean;
  featureFlags?: CxFeatureFlags;
};

export const reducer = (state: SharedState, action: SharedStateAction) => {
  switch (action.type) {
    case SharedStateActionType.set: {
      const isAmazonUser =
        action.userEmail?.endsWith("@amazon.com") ||
        action.userEmail?.endsWith("@onemedical.com") ||
        action.userEmail?.endsWith("+amazon@metriport.com");

      const isTeladocUser =
        action.userEmail?.endsWith("@teladochealth.com") ||
        action.userEmail?.endsWith("+teladochealth@metriport.com");

      return {
        ...state,
        authToken: action.authToken,
        baseUrl: action.baseUrl,
        ehrDetails: action.ehrDetails,
        isLoaded: action.isLoaded,
        isMetriportUser: action.isMetriportUser,
        isUserInSandbox: action.isUserInSandbox,
        userEmail: action.userEmail,
        isAmazonUser,
        isTeladocUser,
        hasDashV2Access: !action.featureFlags?.shouldShowLegacyDashV1,
        featureFlags: action.featureFlags,
      };
    }

    default:
      return state;
  }
};

export const initialState: SharedState = {};
